import { REQUEST_FOR_CALLBACK } from "network/endpoints";
import ewbApi from "network/rfcApi";

export default {
  sendRequestForCallback: (body): void =>
    ewbApi.post(REQUEST_FOR_CALLBACK, body),
};
